import { render, staticRenderFns } from "./tabMarineLicense.vue?vue&type=template&id=0fa15e21&"
import script from "./tabMarineLicense.vue?vue&type=script&lang=js&"
export * from "./tabMarineLicense.vue?vue&type=script&lang=js&"
import style0 from "./tabMarineLicense.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports